import { Component } from 'react';

import classNames from 'classnames';
import _ from 'lodash';
import { defineMessages } from 'react-intl';

import { FormField } from '../formField';
import { FormFieldError } from '../FormFieldError/FormFieldError';
import { Select } from '../select';
import styles from './NameComponent.module.css';
import { titles, titlesDE } from './Titles';
import { getCountry } from '../../iwIntlProvider/CountryProvider';

const messages = defineMessages({
    mr: {
        id: '_.name_field.mr',
        defaultMessage: 'Mr'
    },
    mrs: {
        id: '_.name_field.mrs',
        defaultMessage: 'Mrs'
    },
    ms: {
        id: '_.name_field.ms',
        defaultMessage: 'Ms'
    },
    miss: {
        id: '_.name_field.miss',
        defaultMessage: 'Miss'
    },
    doctor: {
        id: '_.name_field.doctor',
        defaultMessage: 'Doctor'
    },
    professor: {
        id: '_.name_field.professor',
        defaultMessage: 'Professor'
    },
    sir: {
        id: '_.name_field.sir',
        defaultMessage: 'Sir'
    },
    lord: {
        id: '_.name_field.lord',
        defaultMessage: 'Lord'
    },
    lady: {
        id: '_.name_field.lady',
        defaultMessage: 'Lady'
    },
    baron: {
        id: '_.name_field.baron',
        defaultMessage: 'Baron'
    },
    baroness: {
        id: '_.name_field.baroness',
        defaultMessage: 'Baroness'
    },
    rev: {
        id: '_.name_field.reverend',
        defaultMessage: 'Reverend'
    }
});

export class NameComponent extends Component {
    renderError(fields) {
        const fieldWithError = _.find(
            fields,
            (field) => field.meta.touched && field.meta.error
        );

        if (fieldWithError) {
            return (
                fieldWithError.meta.touched &&
                fieldWithError.meta.error && (
                    <FormFieldError message={fieldWithError.meta.error} />
                )
            );
        }
    }

    getOptions = () => {
        if (getCountry() === 'DE') {
            return titlesDE;
        }

        return titles;
    };

    render() {
        const {
            validateHandler,
            names,
            placeholder,
            onChangeHandler,
            disabled,
            title,
            firstName,
            lastName
        } = this.props;

        const nameFields = {
            title: names[0],
            firstName: names[1],
            lastName: names[2]
        };

        const fields = {
            title,
            firstName,
            lastName
        };

        const error = this.renderError(fields);

        return (
            <div className={styles.NameComponent}>
                {error}
                <Select
                    data-testid="title-select"
                    disabled={disabled}
                    className={classNames(styles.title, 'fs-exclude')}
                    name={nameFields.title}
                    onChange={onChangeHandler}
                    validate={validateHandler}
                    hideError={true}
                    placeholder={placeholder.title}
                    messages={messages}
                    selectOptions={{ options: this.getOptions() }}
                />
                <FormField
                    disabled={disabled}
                    className={classNames(styles.firstName, 'fs-exclude')}
                    placeholder={placeholder.first_name}
                    onChangeHandler={onChangeHandler}
                    name={nameFields.firstName}
                    validate={validateHandler}
                    data-testid="first-name-input"
                    hideError={true}
                />
                <FormField
                    disabled={disabled}
                    className={classNames(styles.lastName, 'fs-exclude')}
                    placeholder={placeholder.last_name}
                    onChangeHandler={onChangeHandler}
                    name={nameFields.lastName}
                    data-testid="last-name-input"
                    validate={validateHandler}
                    hideError={true}
                />
            </div>
        );
    }
}
